import React from 'react';
import { Drawer, Popover } from '@mui/material';
import { bool, func, shape, string } from 'prop-types';
import FilterPopover from './FilterPopover.connector';

const cancelButtonStyles = theme => ({
  color: theme.palette.secondary.medium,
  margin: theme.spacing('auto', -0.5, 'auto', 'auto'),
  padding: 0,
});
const filterDrawerStyles = theme => ({
  '& > div': {
    margin: theme.spacing(1, 2, 1.5),
    minWidth: 'unset',
    width: `calc(100% - ${theme.spacing(4)})`,
  },
  '& > hr': {
    marginBottom: theme.spacing(1),
  },
  '& h5': {
    fontSize: 20,
    marginTop: 2,
  },
  borderRadius: '4px 0 0 4px',
  boxShadow: theme.shadows[6],
  display: 'flex',
  flexDirection: 'column',
  padding: theme.spacing(1, 0),
  width: 250,
  [theme.breakpoints.up('lg')]: {
    borderRadius: 0,
    padding: theme.spacing(2),
  },
});

const FiltersContainer = ({ filtersRef, handleClose, lgUp, open, viewBy }) => {
  const cardType = viewBy === 'carrier' ? 'carrier' : 'location';
  const filters = (
    <FilterPopover
      cancelButton={cancelButtonStyles}
      cardType={cardType}
      handleClose={handleClose}
      lgUp={lgUp}
      viewBy={viewBy}
    />
  );

  return lgUp ? (
    <Popover
      anchorEl={filtersRef.current}
      anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      onClose={handleClose}
      open={open}
      sx={{ '& .MuiPaper-root': filterDrawerStyles }}
      transformOrigin={{ horizontal: 'right', vertical: 'top' }}
    >
      {filters}
    </Popover>
  ) : (
    <Drawer
      anchor="right"
      onClose={handleClose}
      open={open}
      slotProps={{
        backdrop: { invisible: true },
      }}
      sx={{ '& .MuiPaper-root': filterDrawerStyles }}
    >
      {filters}
    </Drawer>
  );
};

FiltersContainer.propTypes = {
  filtersRef: shape({}),
  handleClose: func.isRequired,
  lgUp: bool.isRequired,
  open: bool.isRequired,
  viewBy: string.isRequired,
};

FiltersContainer.defaultProps = {
  filtersRef: null,
};

export default FiltersContainer;
